import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { CoborrowerCard } from './card-lenses';

const Cohabitate = ({ model, onChange, ...cardProps }) => (
  <Card title="Do you and your co-borrower currently live together?" {...cardProps}>
    <BooleanRadioButtons
      name="cohabitate"
      value={model.get('cohabitate')}
      onChange={onChange.bind(null, 'cohabitate')}
    />
  </Card>
);

Cohabitate.completed = ({ model }) => model.get('cohabitate') != null;

Cohabitate.id = 'Cohabitate';

export default CoborrowerCard(Cohabitate);



// WEBPACK FOOTER //
// ./src/cards/cohabitation.js